import styles from './error-toast.module.css'

interface ErrorToastProps {
  message: string | undefined
}

export function ErrorToast ({ message }: ErrorToastProps): JSX.Element | null {
  if (!message) {
    return null
  }
  return (
    <div
      className={styles.errorContainer}
    >
      {message}
    </div>
  )
}
